import React, { useState, useRef } from 'react';
import { Box, Badge, Avatar, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { EditRounded as EditRoundedIcon, InsertPhoto as InsertPhotoIcon } from '@mui/icons-material';
import axios from 'axios';
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";

const ProfilePicEditComponent = ({
  fieldName,
  value,
  acceptedFormats = 'image/*',
  onChange,
  isEditable = true
}) => {
  const [selectedImage, setSelectedImage] = useState(value || '');
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);
  const cropperRef = useRef(null);


  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    // Remove spaces and parentheses from the file name
    const cleanedFileName = file.name.replace(/\s+/g, '').replace(/[()]/g, '');
    // Create a new File object with the cleaned file name
    const cleanedFile = new File([file], cleanedFileName, { type: file.type });
    const imageUrl = URL.createObjectURL(cleanedFile);
    setSelectedFile(cleanedFile);
    setSelectedImage(imageUrl);
    setOpenDialog(true);
  };

  // Function to handle cropping and saving the image
  const handleCropSave = () => {
    if (!cropperRef.current || !cropperRef.current.getCroppedCanvas) {
      console.error("Cropper not initialized or getCroppedCanvas function not available.");
      return;
    }

    const canvas = cropperRef.current.getCroppedCanvas();
    if (canvas) {
      canvas.toBlob(
        (blob) => {
          const croppedFile = new File([blob], selectedFile.name || 'croppedImage.jpg', {
            type: selectedFile.type || 'image/jpeg',
          });

          // Update selected image state
          setSelectedImage(URL.createObjectURL(croppedFile));
          // Upload the cropped file
          console.log("selectedImageselectedImage", selectedImage);
          onChange(croppedFile);
          // handleFileUpload(croppedFile);

          // Close dialog after cropping
          setOpenDialog(false);
        },
        'image/jpeg'
      );
    } else {
      console.error("Canvas not available after cropping.");
    }
  };

  // Function to handle file upload to server
  // const handleFileUpload = async (file) => {
  //   if (!file) {
  //     console.error('No file to upload.');
  //     return;
  //   }

  //   try {
  //     const formData = new FormData();
  //     formData.append('file', file);

  //     // const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/uploadpublicblob/generate-sas-url`, formData, {
  //     //   headers: {
  //     //     'Content-Type': 'multipart/form-data',
  //     //   },
  //     // });

  //     // const sasUrl = response.data.url;
  //     console.log("File uploaded successfully!", sasUrl);

  //     onChange(sasUrl); // Pass the uploaded file URL to parent component

  //   } catch (error) {
  //     console.error('Error uploading file:', error.message);
  //     alert('Error uploading file. Please check the console for details.');
  //   }
  // };

  // Function to initialize cropper
  const handleCropperInitialized = (instance) => {
    cropperRef.current = instance;
  };

  // Function to handle file input click on div click
  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click(); // Trigger file input click on div click
    }
  };

  return (
    <Box className="my-2" sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
      <Badge
        overlap="circular"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        badgeContent={isEditable &&
          <Avatar sx={{ bgcolor: "#0044C6" }}>
            <label htmlFor={`${fieldName}-input`} style={{ cursor: "pointer" }}>
              <EditRoundedIcon />
            </label>
            <input
              id={`${fieldName}-input`}
              type="file"
              accept={acceptedFormats}
              style={{ display: 'none' }}
              onChange={handleFileSelect}
            />
          </Avatar>
        }
      >
        <Avatar sx={{ bgcolor: "#F4F7FE", width: "130px", height: "130px" }}>
          {selectedImage !== '' ?
            <img src={selectedImage} alt="profilepicture" className='profile-pic-avatar' />
            : <InsertPhotoIcon sx={{ color: "grey" }} fontSize="large" />
          }
        </Avatar>
      </Badge>
      <div style={{ position: "absolute", marginLeft: 70, marginTop: 40 }} onClick={handleClick}>
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={handleFileSelect}
        />
      </div>


      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Crop Image</DialogTitle>
        <DialogContent>
          <div style={{ width: '100%', height: '400px', position: 'relative' }}>
            <Cropper
              ref={cropperRef}
              src={selectedImage}
              style={{ height: '100%', width: '100%' }}
              initialAspectRatio={1}
              guides={true}
              cropBoxMovable={true}
              cropBoxResizable={true}
              crossOrigin="anonymous"
              dragMode="crop"
              viewMode={1}
              background={false}
              responsive={true}
              autoCrop={false}
              autoCropArea={1}
              minCropBoxHeight={20}
              minCropBoxWidth={20}
              checkOrientation={false}
              onInitialized={handleCropperInitialized}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCropSave}>Save</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ProfilePicEditComponent;
